export const allTermsTypes = [
    "TermsMerchant",
    "TermsUser",
    "TermsPartner",
    "MerchantPartnerAgreement",
    "PrivacyPolicyShared",
    "TermsReturnSell",
    "TermsPlusSell",
    "TermsWinBack",
    "TermsAnywhereMobile",
    "DataProcessingAgreement",
    "TermsAcquiringClearhaus",
    "TermsPayFaqDigiteal",
    "TermsA2a",
    "TermsPSP",
    "TermsKlarna",
    "TermsSwish",
    "TermsApplePay",
    "TermsDankort",
    "TermsViaBill",
    "TermsAnyday",
    "TermsForbrugsforeningen",
    "TermsVippsPsp",
    "TermsVippsEpayment",
    "TermsMobilePayOnline",
    "TermsResurs",
    "TermsExternalAnalytics",
    "TermsTrygUser",
    "TermsBancontact",
    "TermsIdeal",
    "TermsTermsTech",
] as const
export type ETermsType = (typeof allTermsTypes)[number]

export type EDigitealTerms = "GeneralTermsAndConditions" | "ClientSpecificTermsAndConditions" | "DataPrivacyPolicy"

export function getExtraLinksForTermsType(termsType: ETermsType, language: string) {
    if (termsType === "TermsPayFaqDigiteal") {
        return getDigitealTerms(language).map((t) => ({ text: t.title, url: t.url }))
    }
    return []
}

export function getDigitealTerms(language: string): { title: string; url: string; type: EDigitealTerms }[] {
    if (language === "fr") {
        return [
            {
                title: "Conditions générales d'utilisation",
                url: "https://docs.digiteal.eu/Policy/Digiteal-Conditions_Generales_d_Utilisation.pdf",
                type: "GeneralTermsAndConditions",
            },
            {
                title: "Conditions spécifiques aux clients",
                url: "https://docs.digiteal.eu/Policy/Digiteal-Conditions_Specifiques_aux_Clients.pdf",
                type: "ClientSpecificTermsAndConditions",
            },
            {
                title: "Politique de la protection de la vie privée",
                url: "https://docs.digiteal.eu/Policy/Digiteal-Politique_de_la_Protection_de_la_vie_privee.pdf",
                type: "DataPrivacyPolicy",
            },
        ]
    }
    if (language === "nl") {
        return [
            {
                title: "Algemene voorwaarden",
                url: "https://docs.digiteal.eu/Policy/Digiteal-Algemene_Voorwaarden.pdf",
                type: "GeneralTermsAndConditions",
            },
            {
                title: "Klant-specifiek voorwaarden",
                url: "https://docs.digiteal.eu/Policy/Digiteal-Klant-Specifieke_Voorwaarden.pdf",
                type: "ClientSpecificTermsAndConditions",
            },
            {
                title: "Privacybeleid",
                url: "https://docs.digiteal.eu/Policy/Digiteal-Privacybeleid.pdf",
                type: "DataPrivacyPolicy",
            },
        ]
    }
    return [
        {
            title: "General terms and conditions",
            url: "https://docs.digiteal.eu/Policy/Digiteal-General_Terms_and_Conditions.pdf",
            type: "GeneralTermsAndConditions",
        },
        {
            title: "Client specific terms and conditions",
            url: "https://docs.digiteal.eu/Policy/Digiteal-Client-specific_Terms_and_Conditions.pdf",
            type: "ClientSpecificTermsAndConditions",
        },
        {
            title: "Data privacy policy",
            url: "https://docs.digiteal.eu/Policy/Digiteal-Data_Privacy_Policy.pdf",
            type: "DataPrivacyPolicy",
        },
    ]
}
